import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useTeamPageLayoutContext } from "..";
import { ViewToggleButtonGroup } from "../../../components";
import { useBreakpoints } from "../../../hooks";
import { TeamIssuesList, TeamTaskItemsList } from "./components";
import { useTeamImplementationSettings } from "./hooks";

interface IParams {
  slug: string;
}

const TeamImplementationPage = () => {
  const { team } = useTeamPageLayoutContext();
  const { slug: teamSlug } = useParams<keyof IParams>() as IParams;
  const { isMdUp } = useBreakpoints();
  const { settings, updateSettings } = useTeamImplementationSettings(teamSlug);
  const [isTableView, setIsTableView] = useState(true);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamSlug]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, teamSlug, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <Stack spacing={1}>
      <Card>
        <CardContent>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack spacing={0.25}>
              <Typography variant="h5">Implementation</Typography>
              <Typography>Tasks and Issues</Typography>
            </Stack>
            {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
          </Stack>
        </CardContent>
      </Card>
      <Box>
        <Grid container spacing={1}>
          <Grid size={{ lg: isTableView ? 12 : 8, xs: 12 }}>
            <TeamTaskItemsList teamSlug={team.slug} isTableView={isTableView} />
          </Grid>
          <Grid size={{ lg: isTableView ? 12 : 4, xs: 12 }}>
            <TeamIssuesList teamSlug={team.slug} isTableView={isTableView} />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export { TeamImplementationPage };
